import { type PreviewAspectRatio, PreviewValidationError, PreviewValidationErrors } from "../models";

import { isValidAspectRatio } from "./isValidAspectRatio";

export const checkAspectRatioForImage = (url: string, aspectRatio?: PreviewAspectRatio): Promise<void> =>
    new Promise<void>((resolve, reject) => {
        const img = new Image();
        img.addEventListener("load", () => {
            if (isValidAspectRatio(img.width, img.height, undefined, aspectRatio)) {
                resolve();
            } else {
                reject(new PreviewValidationError(PreviewValidationErrors.ImageIncorrectAspectRatio));
            }
        });
        img.addEventListener("error", () => {
            reject(new PreviewValidationError(PreviewValidationErrors.CannotLoad));
        });
        img.src = url;
    });
